import GradientBg from "@/components/common/GradientBg";
import HeadMeta from "@/components/common/HeadMeta";
import Reveal from "@/components/marketing/Reveal";
import { BRAND } from "@/branding.config";

/** Reusable policy shell — clean typographic page for legal content. */
export default function PolicyPage({ title, updated, children, description }) {
  return (
    <>
      <HeadMeta title={title} description={description || `${title} — ${BRAND.app_name}`} />
      <div className="relative">
        <GradientBg variant="soft" />
        <article className="relative mx-auto max-w-3xl px-6 pt-28 pb-32">
          <Reveal>
            <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Legal</div>
            <h1 className="mt-4 text-5xl md:text-6xl font-black tracking-tight">{title}</h1>
            <p className="mt-3 text-sm text-muted-foreground">Last updated: {updated || new Date().toLocaleDateString()}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12 space-y-6 text-muted-foreground leading-relaxed [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-foreground [&>h2]:mt-10 [&>h2]:mb-2 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:space-y-1.5">
              {children}
            </div>
          </Reveal>
        </article>
      </div>
    </>
  );
}
